module.exports = __webpack_public_path__ + "static/media/page-5@2x.bba20a89.png";